<ion-card
  class="container c-card"
  [ngClass]="{ hide_balance_previous_year: shouldHideCard() }"
>
  <div class="line line--text">{{ 'BALANCE.PREVIOUS_YEARS' | translate }}</div>
  <div class="line line--value">{{ value | humanizeDuration : true }}</div>
</ion-card>
